/**
 * Графики
 */

import { buildRoute } from '@direct-frontend/modules-router';

export const dashboardsRoute = buildRoute('/dashboards');
